<template>
  <modal v-bind="$attrs" v-on="$listeners" :errors="errors">
    <template v-slot:title>
      <h1>
        {{ $t($i18nLabelsHelper(organizationType, "invite_new_teacher")) }}
      </h1>
    </template>
    <template v-slot:body>
      <el-form class="auth-form" :model="form" :rules="rules" ref="form">
        <div class="form-row">
          <elsa-input
            name="first_name"
            :label="$t('organizations.users_section.modals.invite_teacher.first_name')"
            class="first-name"
            :placeholder="$t('organizations.users_section.modals.invite_teacher.first_name')"
            v-model.lazy="form.first_name"
          >
            {{
              $t(
                "organization_profile.edit_organization_modal.city_field.label"
              )
            }}
          </elsa-input>
          <elsa-input
            name="last_name"
            :label="$t('organizations.users_section.modals.invite_teacher.last_name')"
            class="last-name"
            :placeholder="$t('organizations.users_section.modals.invite_teacher.last_name')"
            v-model.lazy="form.last_name"
          >
            {{
              $t(
                "organization_profile.edit_organization_modal.state_field.label"
              )
            }}
          </elsa-input>
        </div>
        <elsa-input
          name="email"
          :label="$t('login.email_field.label')"
          :placeholder="$t('login.email_field.placeholder')"
          v-model.trim.lazy="form.email"
        >
          {{ $t("login.email_field.label") }}
        </elsa-input>
        <div class="el-dialog__footer">
          <span class="dialog-footer elsa-button-footer">
            <tertiary-button @click.native="handleCancelClick">
              {{ $t("common.cancel") }}
            </tertiary-button>
            <primary-button
              disabled
              @click.native="handleInvite"
              ref="submit"
              type="submit"
            >
              {{ $t("common.continue") }}
            </primary-button>
          </span>
        </div>
      </el-form>
    </template>
    <template v-slot:footer> </template>
  </modal>
</template>

<script>
import Modal from "@/components/common/Modal";
import PrimaryButton from "@/components/common/buttons/PrimaryButton";
import TertiaryButton from "@/components/common/buttons/TertiaryButton";
import ElsaInput from "@/components/common/Input";
import {
  handleSubmitButtonState,
  isPropEmpty,
  handleFormValidation,
} from "@/helpers/formValidationHelper";

export default {
  components: {
    Modal,
    PrimaryButton,
    TertiaryButton,
    ElsaInput,
  },
  props: {
    organizationType: {
      type: String,
    },
  },
  data() {
    return {
      errors: [],
      form: {},
      rules: {
        email: [
          {
            type: "email",
            message: this.$t('organizations.users_section.modals.invite_teacher.email_validation_msg'),
            trigger: "blur",
            required: true,
          },
        ],
        first_name: [
          {
            type: "string",
            message: this.$t('organizations.users_section.modals.invite_teacher.first_name_validation_msg'),
            trigger: "blur",
            required: true,
          },
        ],
        last_name: [
          {
            type: "string",
            message: this.$t('organizations.users_section.modals.invite_teacher.last_name_validaion_msg'),
            trigger: "blur",
            required: true,
          },
        ],
      },
    };
  },
  methods: {
    handleInvite(e) {
      e.preventDefault();
      return handleFormValidation(
        this.$refs.form,
        this.inviteUsers,
        this.handleError
      );
    },
    inviteUsers() {
      this.$emit("newTeacher", {
        email: this.form.email,
        first_name: this.form.first_name,
        last_name: this.form.last_name,
      });
      this.resetModal();
    },
    handleCancelClick() {
      this.resetModal();
    },
    onFormChange() {
      return handleSubmitButtonState(
        this.$refs.submit.$el,
        !isPropEmpty("email")(this.form)
      );
    },
    handleError(error) {
      this.errors = error;
    },
    resetModal() {
      this.errors = [];
      this.$refs.form.resetFields();
      handleSubmitButtonState(this.$refs.submit.$el, true);
      this.$emit("closed");
    },
  },
  watch: {
    form: {
      deep: true,
      handler() {
        return this.onFormChange();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.elsa-flat-button.el-button {
  padding: 0;
  margin: 0;
}

::v-deep .el-form .el-form-item .el-form-item__label {
  text-transform: capitalize;
}
.auth-form {
  .form-row {
    display: flex;
    .first-name,
    .last-name {
      width: 50%;
    }
    .first-name {
      margin-right: 30px;
    }
  }
}
</style>
<style lang="scss">
.elsa-button-footer {
  padding: 30px 0px 0px;
}
</style>
>
